import React from 'react'
import { PropTypes } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import styles from './span.styl'

const Span = ({
  children,
  uppercase,
  error,
  alignWithInput,
  strong,
  intlKey,
  link,
  onClick,
  muted,
  textOverflow,
  negative,
  style
}) => {
  return (
    <span
      className={cx({
        [styles.uppercase]: uppercase,
        [styles.error]: error,
        [styles.alignWithInput]: alignWithInput,
        [styles.strong]: strong,
        [styles.muted]: muted,
        [styles.textOverflow]: textOverflow,
        [styles.negative]: negative,
        [styles.link]: link
      })}
      onClick={onClick}
      style={style}
    >
      {intlKey
        ? <FormattedMessage id={intlKey} defaultMessage={children} />
        : children}
    </span>
  )
}

Span.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  uppercase: PropTypes.bool,
  error: PropTypes.bool,
  alignWithInput: PropTypes.bool,
  link: PropTypes.bool,
  strong: PropTypes.bool,
  muted: PropTypes.bool,
  textOverflow: PropTypes.bool,
  negative: PropTypes.bool,
  intlKey: PropTypes.string,
  style: PropTypes.object
}

export default Span
